<template>
  <v-card class="px-2 py-2 intern-expansion-panel" flat tile>
    <v-card class="d-flex justify-end mt-0" flat tile>
      <v-btn small class="px-2" color="primary" @click="handleAddCondition">
        Adicionar
        <v-icon class="ml-2" small>add</v-icon>
      </v-btn>
    </v-card>

    <v-expansion-panels v-for="(condition, i) in value" :key="i" class="pt-2" hover multiple focusable tile>
      <v-expansion-panel>
        <v-expansion-panel-header class="pl-2 pr-0">
          <span class="text-subtitle-2 font-weight-medium grey--text text--darken-3">Condition-{{ i + 1 }}</span>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="py-2 px-2">
          <v-row class="mt-2 d-flex justify-space-between" no-gutters>
            <p class="text-subtitle-2 mb-0 grey--text text--darken-3">Regras para Tab</p>
            <v-icon color="red" @click="handleRemoveCondition(i)" small>delete</v-icon>
          </v-row>

          <v-row justify="space-around" no-gutters>
            <v-col cols="6">
              <v-select
                :items="operators"
                v-model="condition.operator"
                label="Operator"
                class="mr-2"
                hide-details
                append-icon="zmdi zmdi-chevron-down"
              />
            </v-col>

            <v-col cols="6">
              <v-text-field label="Tab" v-model="condition.tab" hide-details />
            </v-col>

            <v-col cols="12">
              <p class="text-subtitle-2 mb-0 grey--text text--darken-3 mt-2">Ações</p>

              <v-list dense>
                <v-list-item-group>
                  <v-list-item v-for="(item, index) in condition.action" :key="index" class="px-2">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <div class="d-flex justify-space-between align-center mt-0" flat tile>
                          <v-row justify="space-around" no-gutters>
                            <v-col cols="6">
                              <v-select
                                :items="['hide', 'disable']"
                                v-model="Object.keys(item)[0]"
                                label="Operator"
                                class="mr-1"
                                hide-details
                                append-icon="zmdi zmdi-chevron-down"
                                @change="handleUpdateActionKey($event, index, i)"
                              />
                            </v-col>

                            <v-col cols="6">
                              <v-text-field
                                v-model="Object.values(item)[0]"
                                label="Value"
                                class="ml-1"
                                hide-details
                                @change="handleUpdateActionValue($event, index, i)"
                              />
                            </v-col>
                          </v-row>

                          <div>
                            <v-icon color="red" small @click="handleRemoveAction(index, i)">delete</v-icon>
                          </div>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>

            <v-col cols="12" class="d-flex justify-end">
              <v-btn small class="px-2" color="primary" @click="handleAddAction(i)">
                Adicionar
                <v-icon class="ml-2" small>add</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="space-around" no-gutters>
            <v-col cols="12">
              <p class="text-subtitle-2 mb-0 grey--text text--darken-3 mt-2">Condições</p>

              <v-list dense>
                <v-list-item-group>
                  <v-list-item v-for="(item, index) in condition.condition" :key="index" class="px-2">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <div class="d-flex justify-space-between align-center mt-0" flat tile>
                          <v-row justify="space-around" no-gutters>
                            <v-col cols="4">
                              <v-text-field
                                v-model="item.field"
                                label="Field"
                                class="ml-1"
                                hide-details
                                @change="handleUpdateActionValue($event, index, i)"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-select
                                :items="operators"
                                v-model="item.operator"
                                label="Operator"
                                class="mr-2"
                                hide-details
                                append-icon="zmdi zmdi-chevron-down"
                              />
                            </v-col>

                            <v-col cols="4">
                              <v-text-field
                                v-model="item.value"
                                label="Value"
                                class="ml-1"
                                hide-details
                                @change="handleUpdateActionValue($event, index, i)"
                              />
                            </v-col>
                          </v-row>

                          <div>
                            <v-icon color="red" small @click="handleRemoveConditionRule(index, i)">delete</v-icon>
                          </div>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>

            <v-col cols="12" class="d-flex justify-end">
              <v-btn small class="px-2" color="primary" @click="handleAddConditionRule(i)">
                Adicionar
                <v-icon class="ml-2" small>add</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
export default {
  props: {
    value: { type: [Object, Array], default: () => ({} || []) }
  },

  data: () => ({
    operators: ['==', '!=', '>', '>=', '<', '<=']
  }),

  methods: {
    handleAddCondition() {
      let condition = {
        operator: '==',
        tab: 1,
        action: [{ hide: 0 }],
        condition: []
      };

      this.value.push(condition);
    },

    handleAddConditionRule(i) {
      let condition = {
        operator: '==',
        field: '',
        value: ''
      };

      this.value[i].condition.push(condition);
    },

    handleRemoveConditionRule(index, element) {
      this.value[element].condition.splice(index, 1);
    },

    handleRemoveCondition(parentIndex) {
      this.value.splice(parentIndex, 1);
    },

    handleRemoveAction(index, parentIndex) {
      this.value[parentIndex].action.splice(index, 1);
    },

    handleAddAction(parentIndex) {
      this.value[parentIndex].action.push({ hide: 0 });
    },

    handleUpdateActionKey(e, index, parentIndex) {
      const oldKey = e === 'hide' ? 'disable' : 'hide';
      const currentValue = this.value[parentIndex].action[index][oldKey];

      this.value[parentIndex].action.splice(index, 1, { [e]: currentValue });
    },

    handleUpdateActionValue(e, index, parentIndex) {
      'hide' in this.value[parentIndex].action[index] && (this.value[parentIndex].action[index].hide = parseInt(e));
      'disable' in this.value[parentIndex].action[index] && (this.value[parentIndex].action[index].disable = parseInt(e));
    }
  }
};
</script>
